var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalloonColorMatchLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.87 21.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.92,4.76h5.96c2.3,0,3.39,1.57,3.39,3.08,0,1.21-.65,2.45-1.91,2.88,1.55.43,2.34,1.71,2.34,3.04,0,1.87-1.48,3.6-4.12,3.6H3.92V4.76ZM9.15,9.86c1.17,0,1.75-.7,1.75-1.53,0-.77-.52-1.4-1.6-1.4h-3.06v2.93h2.92ZM9.34,15.21c1.37,0,2-.86,2-1.8,0-.88-.63-1.67-1.89-1.67h-3.22v3.48h3.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.84,4.76h2.65l4.92,12.6h-2.48l-1.1-2.97h-5.31l-1.1,2.97h-2.48l4.92-12.6ZM23.06,12.31l-1.89-5.17-1.91,5.17h3.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.34,4.76h2.3v10.44h5.91v2.16h-8.21V4.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.49,4.76h2.3v10.44h5.91v2.16h-8.21V4.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.85,11.06c0-3.62,2.21-6.61,6.23-6.61s6.23,2.99,6.23,6.61-2.21,6.63-6.23,6.63-6.23-3.01-6.23-6.63ZM55.08,15.57c2.56,0,3.87-1.94,3.87-4.5s-1.31-4.48-3.87-4.48-3.87,1.93-3.87,4.48,1.31,4.5,3.87,4.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.07,11.06c0-3.62,2.21-6.61,6.23-6.61s6.23,2.99,6.23,6.61-2.21,6.63-6.23,6.63-6.23-3.01-6.23-6.63ZM69.3,15.57c2.56,0,3.87-1.94,3.87-4.5s-1.31-4.48-3.87-4.48-3.87,1.93-3.87,4.48,1.31,4.5,3.87,4.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.92,4.76h2.72l5.49,9.02V4.76h2.3v12.6h-2.65l-5.56-9.13v9.13h-2.3V4.76Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.26,11.15c0-3.96,2.47-6.7,6.27-6.7,3.01,0,5.28,1.71,5.44,4.61h-2.36c-.13-1.55-1.35-2.48-3.15-2.48-2.47,0-3.85,1.82-3.85,4.48,0,2.39,1.12,4.5,3.82,4.5,1.8,0,3.17-.94,3.24-2.86h2.36c-.14,3.31-2.63,4.99-5.76,4.99-4.12,0-6-3.12-6-6.54Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.68,11.06c0-3.62,2.21-6.61,6.23-6.61s6.23,2.99,6.23,6.61-2.21,6.63-6.23,6.63-6.23-3.01-6.23-6.63ZM114.91,15.57c2.56,0,3.87-1.94,3.87-4.5s-1.31-4.48-3.87-4.48-3.87,1.93-3.87,4.48,1.31,4.5,3.87,4.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.53,4.76h2.3v10.44h5.91v2.16h-8.21V4.76Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.89,11.06c0-3.62,2.21-6.61,6.23-6.61s6.23,2.99,6.23,6.61-2.21,6.63-6.23,6.63-6.23-3.01-6.23-6.63ZM139.12,15.57c2.56,0,3.87-1.94,3.87-4.5s-1.31-4.48-3.87-4.48-3.87,1.93-3.87,4.48,1.31,4.5,3.87,4.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.74,4.76h5.78c2.68,0,4.02,1.85,4.02,3.75,0,1.58-.86,3.04-2.56,3.6l3.26,5.26h-2.7l-2.83-4.79h-2.66v4.79h-2.3V4.76ZM153.09,10.6c1.39,0,2.09-.81,2.09-1.89s-.67-1.78-2.03-1.78h-3.1v3.67h3.04Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.32,4.76h3.3l3.46,9.89,3.46-9.89h3.29v12.6h-2.2V7.75l-3.33,9.61h-2.45l-3.33-9.61v9.61h-2.2V4.76Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.68,4.76h2.65l4.92,12.6h-2.48l-1.1-2.97h-5.31l-1.1,2.97h-2.48l4.92-12.6ZM187.9,12.31l-1.89-5.17-1.91,5.17h3.8Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.64,6.92h-4.14v-2.16h10.61v2.16h-4.16v10.44h-2.3V6.92Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.71,11.15c0-3.96,2.47-6.7,6.27-6.7,3.01,0,5.28,1.71,5.44,4.61h-2.36c-.13-1.55-1.35-2.48-3.15-2.48-2.47,0-3.85,1.82-3.85,4.48,0,2.39,1.12,4.5,3.82,4.5,1.8,0,3.17-.94,3.24-2.86h2.36c-.14,3.31-2.63,4.99-5.76,4.99-4.12,0-6-3.12-6-6.54Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.77,4.76h2.3v5.17h5.6v-5.17h2.3v12.6h-2.3v-5.28h-5.6v5.28h-2.3V4.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonColorMatchLogoBlack);
export default __webpack_public_path__ + "static/media/balloon-color-match-logo-black.d1bddcc2f8478648fde96ff18c4a3b6d.svg";
export { ForwardRef as ReactComponent };